export default "__VITE_ASSET__Cwj2NBDf__"